/**
 * Display helpers for the §A Locations card (wayfinder L9).
 * Names come from street/city — never a generated loc-* slug.
 */
import { composeAddress, type AddressParts } from '../sections/locationMerge';

export function nameFromStreet(street?: string | null, city?: string | null): string {
  const fromStreet = (street ?? '')
    .trim()
    .replace(/^\d+\s+/, '')
    .replace(/\s+(Rd|Ave|St|Blvd|Dr|Ln|Hwy|Way|Ct)\.?$/i, '')
    .trim();
  return fromStreet || (city ?? '').trim();
}

export function isGeneratedLocationKey(key: string | undefined): boolean {
  return Boolean(key && /^(loc|clinic)-[a-z0-9]+$/i.test(key));
}

export function displayLocationName(locationKey: string | undefined, parts: AddressParts): string {
  if (!locationKey || isGeneratedLocationKey(locationKey)) {
    return nameFromStreet(parts.street, parts.city) || 'New location';
  }
  if (locationKey === 'primary') return 'Primary';
  return locationKey.replace(/[-_]+/g, ' ').replace(/\b([a-z])/g, (ch) => ch.toUpperCase());
}

export function composedLocationLine(parts: AddressParts, fallback?: string | null): string {
  return composeAddress(parts) || (fallback ?? '').trim();
}

export function cityServiceAreaLabel(parts: AddressParts): string | null {
  const city = (parts.city ?? '').trim();
  if (!city) return null;
  const state = (parts.state ?? '').trim();
  return state ? `${city}, ${state}` : city;
}

export function slugFromLocationName(name: string): string {
  const slug = name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return slug.slice(0, 48);
}
